/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Remind_TitleInputs */

const en_how_page_remind_title = /** @type {(inputs: How_Page_Remind_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing slips by.`)
};

const pl_how_page_remind_title = /** @type {(inputs: How_Page_Remind_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nic Ci nie umknie.`)
};

/**
* | output |
* | --- |
* | "Nothing slips by." |
*
* @param {How_Page_Remind_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_remind_title = /** @type {((inputs?: How_Page_Remind_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Remind_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_remind_title(inputs)
	return en_how_page_remind_title(inputs)
});